/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderInfoForClientSkuVo
 */
export interface OrderInfoForClientSkuVo {
    /**
     * 订单ID
     * @type {number}
     * @memberof OrderInfoForClientSkuVo
     */
    orderId?: number;
    /**
     * 订单编码
     * @type {string}
     * @memberof OrderInfoForClientSkuVo
     */
    orderCode?: string;
    /**
     * 接收人姓名
     * @type {string}
     * @memberof OrderInfoForClientSkuVo
     */
    receiverName?: string;
    /**
     * 接收人手机号
     * @type {string}
     * @memberof OrderInfoForClientSkuVo
     */
    mobileNo?: string;
    /**
     * 数量
     * @type {number}
     * @memberof OrderInfoForClientSkuVo
     */
    quantity?: number;
    /**
     * 平台
     * @type {number}
     * @memberof OrderInfoForClientSkuVo
     */
    platform?: number;
    /**
     * 平台名称
     * @type {string}
     * @memberof OrderInfoForClientSkuVo
     */
    platformName?: string;
    /**
     * 订单状态
     * @type {number}
     * @memberof OrderInfoForClientSkuVo
     */
    orderStatus?: number;
    /**
     * 订单状态名称
     * @type {string}
     * @memberof OrderInfoForClientSkuVo
     */
    orderStatusName?: string;
    /**
     * 跟踪号
     * @type {string}
     * @memberof OrderInfoForClientSkuVo
     */
    trackingNumber?: string;
    /**
     * 费用
     * @type {number}
     * @memberof OrderInfoForClientSkuVo
     */
    billAmount?: number;
    /**
     * 1 同种，0 不同种
     * @type {number}
     * @memberof OrderInfoForClientSkuVo
     */
    singleSku?: number;
    /**
     * 接收人地址
     * @type {string}
     * @memberof OrderInfoForClientSkuVo
     */
    receiveAddress?: string;
    /**
     * 订单创建时间
     * @type {string}
     * @memberof OrderInfoForClientSkuVo
     */
    createTime?: string;
    /**
     * 客户端按钮编码列表
     * @type {Array<string>}
     * @memberof OrderInfoForClientSkuVo
     */
    clientButtonCodes?: Array<string>;
}

/**
 * Check if a given object implements the OrderInfoForClientSkuVo interface.
 */
export function instanceOfOrderInfoForClientSkuVo(value: object): value is OrderInfoForClientSkuVo {
    return true;
}

export function OrderInfoForClientSkuVoFromJSON(json: any): OrderInfoForClientSkuVo {
    return OrderInfoForClientSkuVoFromJSONTyped(json, false);
}

export function OrderInfoForClientSkuVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderInfoForClientSkuVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'mobileNo': json['mobileNo'] == null ? undefined : json['mobileNo'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'platform': json['platform'] == null ? undefined : json['platform'],
        'platformName': json['platformName'] == null ? undefined : json['platformName'],
        'orderStatus': json['orderStatus'] == null ? undefined : json['orderStatus'],
        'orderStatusName': json['orderStatusName'] == null ? undefined : json['orderStatusName'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'billAmount': json['billAmount'] == null ? undefined : json['billAmount'],
        'singleSku': json['singleSku'] == null ? undefined : json['singleSku'],
        'receiveAddress': json['receiveAddress'] == null ? undefined : json['receiveAddress'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'clientButtonCodes': json['clientButtonCodes'] == null ? undefined : json['clientButtonCodes'],
    };
}

export function OrderInfoForClientSkuVoToJSON(json: any): OrderInfoForClientSkuVo {
    return OrderInfoForClientSkuVoToJSONTyped(json, false);
}

export function OrderInfoForClientSkuVoToJSONTyped(value?: OrderInfoForClientSkuVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'orderCode': value['orderCode'],
        'receiverName': value['receiverName'],
        'mobileNo': value['mobileNo'],
        'quantity': value['quantity'],
        'platform': value['platform'],
        'platformName': value['platformName'],
        'orderStatus': value['orderStatus'],
        'orderStatusName': value['orderStatusName'],
        'trackingNumber': value['trackingNumber'],
        'billAmount': value['billAmount'],
        'singleSku': value['singleSku'],
        'receiveAddress': value['receiveAddress'],
        'createTime': value['createTime'],
        'clientButtonCodes': value['clientButtonCodes'],
    };
}

